:host {
    display: flex;
    padding: 15px 10px;
    border-inline-end: 1px solid #9ea9b0;
    border-block-end: 1px solid #9ea9b0;
    grid-column: auto / span var(--ux-cell-span);
    gap: 0 10px;
    position: relative;
}

:host([borderless]) {
    border: 0;
}

::slotted(ux-copy) {
    margin-block-start: 0;
    margin-block-end: 0;
}

:host([sortable]) {
    cursor: pointer;
}

:host([head]) {
    flex-direction: row;
    text-transform: uppercase;
    background-color: #c3cfd6;

    #labelContainer {
        @container style(--trumpf-ux-theme: web) {
            align-items: end;
        }

        align-items: normal;
    }
}

:host([sorted][head]) {
    #labelContainer {
        border-color: black;
    }
}

#labelContainer {
    display: flex;
    align-items: center;
    gap: 0 10px;
    padding-block-start: 5px;
    padding-block-end: 5px;
    border-block-end: 1px solid transparent;
}

:host(:not([head]):hover) {
    background-color: var(--ux-table-col-hover-color, #f0f0f0);
}

#resize {
    position: absolute;
    right: -15px;
    top: 0;
    bottom: 0;
    border: none;
    z-index: 10;
    cursor: col-resize;
    transform: ease-in 0.2s max-width;
    background-color: transparent;
    padding: 5px 15px;
    transition: background-color 0.2s ease, transform 0.2s ease;
    outline: none;

    &.onresize {
        transform: scale(0.9);
    }

    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        right: 4px;
        width: 0;
        height: 0;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #9ea9b0;
    }

    &:focus-visible {
        background-color: #9ea9b0;
        transform: scale(0.9);

        &:after {
            content: unset;
        }
    }

    &:hover {
        background-color: #9ea9b0;

        &:after {
            content: unset;
        }
    }
}